import { Box } from "@mui/material";

import { useAppSelector } from "app/redux-store-interactions";
import {
    // MeasureMenuToolbar,
    // MeasurePickerToolbar,
    PinsToolbar,
    QUICK_ACCESS_TOOLBAR,
    SettingsToolbar,
    ToolModeConfirmationToolbar,
    ToolsMenuToolbar,
    UndoRedoToolbar,
    ViewToolbar,
} from "components/toolbars";
import { CurrentModeToolbar } from "components/toolbars/implementations/CurrentModeToolbar";
import { OverflowToolbar } from "components/toolbars/implementations/OverflowToolbar";
import { AxisSphere } from "features/axisSphere/AxisSphere";
import { useNonMarkerUIIsHidden } from "features/markers/markerCreationUtils";
import { selectIsSubtreesPanelOpen, selectPicker } from "features/render";
import { selectIsAxisSphereVisible, selectIsProcoreBeta } from "slices/explorer";
import { ProcoreToolMode, selectActiveToolMode } from "slices/procoreUx";

import { ToolSettings } from "./toolSettings";

const columnFlexStyles = {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
} as const;

export function QuickAccessMenu() {
    const picker = useAppSelector(selectPicker);
    const isProcoreBeta = useAppSelector(selectIsProcoreBeta);
    const isAxisSphereVisible = useAppSelector(selectIsAxisSphereVisible);
    const nonMarkerUIIsHidden = useNonMarkerUIIsHidden();
    const isSubtreesPanelOpen = useAppSelector(selectIsSubtreesPanelOpen);
    const hasOpenFlyout = isSubtreesPanelOpen;
    const activeToolMode = useAppSelector(selectActiveToolMode);

    if (!isProcoreBeta) {
        return null;
    }

    return (
        <Box
            sx={{
                position: "absolute",
                right: "8px",
                top: "8px",
                pointerEvents: "none",
                display: "flex",
                flexDirection: "row-reverse",
                alignItems: "start",
                gap: "8px",
            }}
        >
            <Box
                sx={{
                    ...columnFlexStyles,
                    zIndex: hasOpenFlyout ? QUICK_ACCESS_TOOLBAR.FLYOUT_Z_INDEX : undefined,
                }}
            >
                <PinsToolbar picker={picker} id="pins-toolbar-close" />
                {activeToolMode === ProcoreToolMode.Default && (
                    <Box
                        sx={{
                            visibility: nonMarkerUIIsHidden ? "hidden" : undefined,
                            pointerEvents: nonMarkerUIIsHidden ? "none" : undefined,
                        }}
                    >
                        <ViewToolbar id="quick-access-camera" />
                    </Box>
                )}
                <Box
                    sx={{
                        ...columnFlexStyles,
                        visibility: nonMarkerUIIsHidden ? "hidden" : undefined,
                        pointerEvents: nonMarkerUIIsHidden ? "none" : undefined,
                    }}
                >
                    <ToolModeConfirmationToolbar />
                    <ToolSettings />
                    <CurrentModeToolbar id="current-mode-toolbar" />
                    <OverflowToolbar id="overflow-toolbar" />
                    {activeToolMode === ProcoreToolMode.Default && <ToolsMenuToolbar id="quick-access-tools-menu" />}
                    <UndoRedoToolbar id="quick-access-undo-redo" />
                    <SettingsToolbar id="quick-access-settings" />
                </Box>
            </Box>

            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "4px",
                    alignItems: "flex-end",
                }}
            >
                {isAxisSphereVisible && <AxisSphere />}
            </Box>
        </Box>
    );
}
